<style lang="less">
@import "./styles/menu.less";
</style>

<template>
  <div :style="{ background: bgColor }" class="ivu-shrinkable-menu">
    <slot name="top"></slot>
    <!-- 展开 -->
    <sidebar-menu
      v-show="!shrink"
      :menu-theme="theme"
      :menu-list="menuList"
      :open-names="openNames"
      :menuShow="menuShow"
      :isDown="isDown"
      @on-change="handleChange"
      @on-open-change="handleResize"
      @changeShow="changeShow"
      @changeDpwm="changeDpwm"
    ></sidebar-menu>
    <!-- 收起 -->
    <sidebar-menu-shrink
      v-show="shrink"
      :menu-theme="theme"
      :menu-list="menuList"
      :icon-color="shrinkIconColor"
      @on-change="handleChange"
    ></sidebar-menu-shrink>
  </div>
</template>

<script>
import sidebarMenu from "./components/sidebarMenu.vue";
import sidebarMenuShrink from "./components/sidebarMenuShrink.vue";
import util from "@/libs/util";
import { mapMutations } from "vuex";

export default {
  name: "shrinkableMenu",
  components: {
    sidebarMenu,
    sidebarMenuShrink,
  },
  props: {
    shrink: {
      type: Boolean,
      default: false,
    },
    menuShow: [Boolean, String],
    isDown: [Boolean],
    menuList: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      default: "dark",
      validator(val) {
        return util.oneOf(val, ["dark", "light"]);
      },
    },
    openNames: {
      type: Array,
    },
  },

  computed: {
    bgColor() {
      return this.theme === "dark" ? "#383C4D" : "#fff";
    },
    shrinkIconColor() {
      return this.theme === "dark" ? "#fff" : "#383C4D";
    },
  },
  methods: {
    ...mapMutations([
      "SET_FROM_DASHBOARD",
      "SET_DASHBOARD_TITLE",
      "SET_BOOKMARK_INFO",
    ]),
    handleResize() {
      this.$emit("on-open-change");
    },
    changeShow(v) {
      this.$emit("changeShow", v);
    },
    changeDpwm(v) {
      this.$emit("changeDpwm", v);
    },

    handleChange(name, projectId) {
      /*if (/Dashboard/.test(name)) {
          return false;
        } else */

      // 路由选择
      if (/dashboards/.test(name)) {
        let dashboardTitle = {};
        dashboardTitle.name = name.substring(name.indexOf("_") + 1);
        // let dashboardTitle = name.substring(name.indexOf("_") + 1);
        dashboardTitle.id = projectId;
        this.$router.push({
          path: `/view/dashboards/${projectId}`,
        });

        this.SET_DASHBOARD_TITLE(dashboardTitle);
      } else if (!/Dashboard/.test(name)) {
        if (name == "customized-queries") {
          const { href } = this.$router.resolve({
            name: "queries",
          });
          window.open(href, "_blank");
        } else {
          this.$router.push({
            path: `/view/${name}/${projectId}`,
          });
        }
      } else {
        return false;
      }
      this.SET_FROM_DASHBOARD(false);
      this.SET_BOOKMARK_INFO({});

      this.$emit("on-change", name);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/main-components/shrinkable-menu/shrinkable-menu.vue